import { Skeleton } from '@/components/ui/skeleton'

/**
 * Generic Suspense fallback for lazy-loaded route chunks (see AppRouter.tsx's
 * lazyPage/ADR-084). Shown only while a page's JS chunk is downloading —
 * usually instant once cached, but a real gap on first/cold-cache visits.
 * Route-agnostic on purpose: each page's own skeleton (e.g. OfferDetailSkeleton)
 * takes over once its chunk has loaded and the component mounts.
 */
export function RouteLoadingFallback() {
  return (
    <div className="h-full py-6 space-y-4">
      <Skeleton className="h-6 w-40" />
      <Skeleton className="h-40 w-full rounded-2xl" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
  )
}
